import { FundType } from "@rentablo/api/recommender";

export const getRecommendationType = (type?: FundType | null) => {
  if (type === "ETF") return "ETF";
  if (type === "MUTUAL_FUND") return "FONDS";
  return "";
};
